module.exports = __webpack_public_path__ + "static/media/zoom-.d98e12c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/components/common/img/zoom-.svg
// module id = 909
// module chunks = 0